import { useState } from "react";
import { type ConfirmProps } from "./Interfaces";

//components
import { BreadCrumbs, Button } from "@atoms";

export const ConfirmData = ({ os, ...props }: ConfirmProps) => {
  const [description, setDescription] = useState<string>(props.macro);

  if (props.loading) {
    return (
      <div className="w-full h-[50px]">
        <p>carregando...</p>
      </div>
    );
  }

  return (
    <div>
      <BreadCrumbs items={["OS", "Consulta"]} />

      <div className="w-full max-h-[65vh]">
        <div className="w-[97%] ml-[5px] h-[65vh]">
          <textarea
            className="w-[95%] h-[150px] p-[15px] rounded-[4px] resize-none outline-none border-[#D8DCDE] text-[16  px]"
            value={description}
            onChange={(e) => {
              setDescription(e.target.value);
            }}
          />
        </div>

        <div className="w-full border-t border-[#D8DCDE] flex flex-col gap-[20px] bg-white">
          <Button
            onClick={() => {
              props.handleCreate(os, description, Number(props.mainTicket));
            }}
          >
            Confirmar dados
          </Button>
          <Button onClick={props.backPage}>Voltar</Button>
        </div>
      </div>
    </div>
  );
};
